import DomCreate from "./domCreate.js";

// Link content built from data-* attributes of user content, so never via innerHTML
export default function secureLinkContent(icon, text) {
    const content = [];
    if (icon && /^[a-z0-9-]+$/.test(icon)) {
        const iconWrapper = DomCreate.create("span", ["icon"]);
        iconWrapper.appendChild(DomCreate.create("i", ["fa-solid", "fa-" + icon]));
        content.push(iconWrapper);
    }
    const textElement = DomCreate.create("span");
    textElement.textContent = text;
    content.push(textElement);
    return content;
}
